export default [
    {
        path: '/expenses',
        name: 'Company / Expenses',
        component: () => import('@/views/pages/expenses'),
        meta:
        {
            page: 'list',
        },
        children:
        [
            {
                path: 'overview',
                name: 'Company / Expense Overview',
                component: () => import('@/views/pages/expenses'),
                meta:
                {
                    page: 'overview',
                },
            },
            {
                path: 'payments',
                name: 'Company / Expense Payments',
                component: () => import('@/views/pages/expenses'),
                meta:
                {
                    page: 'payments',
                },
            },
            {
                path: ':code',
                name: 'Company / View Expense',
                component: () => import('@/views/pages/expenses'),
                meta:
                {
                    page: 'view',
                },
            },
        ],
    },
];